"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoneUserRoles = void 0;
exports.HoneUserRoles = {
    Bookkeeper: "Bookkeeper",
    Bookkeeper_Account_Admin: "Bookkeeper_Account_Admin",
    Employee: "Employee",
    Owner: "Owner" // User that can view all public/private published reports
};
//# sourceMappingURL=User.js.map